import React, { createContext, useContext, useState, useEffect } from 'react';

const SnackbarContext = createContext();

export const useSnackbar = () => {
    return useContext(SnackbarContext);
};

export const SnackbarProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [text, setText] = useState('');
    const [error, setError] = useState(false);
    const [element, setElement] = useState(false)

    const showSnackbar = (message, error = false, element = false) => {
        setIsOpen(true);
        setText(message);
        setError(error);
        setElement(element);
    };

    const hideSnackbar = () => {
        setIsOpen(false);
        setText('');
    };


    return (
        <SnackbarContext.Provider value={{ isOpen, text, element, error, showSnackbar, hideSnackbar }}>
            {children}
        </SnackbarContext.Provider>
    );
};